export default {
      id: "clock-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "assets/icons/icon-sprite.svg#clock-usage",
      toString: function () {
        return this.url;
      }
    }